import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="promoters--seller-infos--promoter-events"
export default class extends Controller {
  static targets = ["pin"];

  connect() {
    this.checkPin();
  }

  // ピン留めの監視
  checkPin() {
    const pinnedCount = this.pinTargets.filter((pin) => pin.checked).length;
    if (pinnedCount >= 2) {
      this.disableUnPinned();
    } else {
      this.enableUnPinned();
    }
  }

  // 未チェックのピン留めを有効化する
  enableUnPinned() {
    this.pinTargets
      .filter((pin) => !pin.checked)
      .forEach((unpinned) => {
        if (!unpinned.closest("li").classList.contains("is-disabled")) {
          unpinned.removeAttribute("disabled");
        }
      });
  }

  // 未チェックのピン留めを無効化する
  disableUnPinned() {
    this.pinTargets
      .filter((pin) => !pin.checked)
      .forEach((unpinned) => {
        if (!unpinned.closest("li").classList.contains("is-disabled")) {
          unpinned.setAttribute("disabled", true);
        }
      });
  }

  // modal_controller.jsのshowを呼び出す
  modalShow(event) {
    const targetId = event.currentTarget.dataset.targetId;
    const modalController = this.application.getControllerForElementAndIdentifier(
      document.getElementById(targetId),
      "modal",
    );
    modalController.show();
  }
}
